import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    id: 'components.Loading.errorTitle',
    defaultMessage: 'Loadable Error',
    description: '备注',
  },
  errorDes: {
    id: 'components.Loading.errorDes',
    defaultMessage: 'please try later!',
    description: '备注',
  },
  timeoutTitle: {
    id: 'components.Loading.timeoutTitle',
    defaultMessage: 'Taking a long time',
    description: '备注',
  },
  timeoutDes: {
    id: 'components.Loading.timeoutDes',
    defaultMessage: 'please try later!',
    description: '备注',
  },
  btn: {
    id: 'components.Loading.btn',
    defaultMessage: 'RETRY',
    description: '备注',
  },
})
